function buildSocialRoutes({
  routes,
  onEnterProfile,
  errorLoading,
  createConditionalComponent,
  userProfile2Enabled,
}) {
  return routes.concat([
    {
      path: 'profile/thumbs(/:webname)',
      onEnter: onEnterProfile,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/containers/UserProfile/UserProfile`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
      getIndexRoute(location, cb) {
        System.import(
          /* webpackChunkName: "c_thumbs-up" */ `${BASE_PATH}/src/components/UserProfile/ThumbUps/ThumbUps`,
        )
          .then(module => {
            cb(null, { component: module.default });
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'profile/followers(/:webname)',
      onEnter: onEnterProfile,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/containers/UserProfile/UserProfile`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
      getIndexRoute(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/components/UserProfile/Profile/Profile`,
        )
          .then(module => {
            cb(null, { component: module.default });
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'profile/following(/:webname)',
      onEnter: onEnterProfile,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/containers/UserProfile/UserProfile`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
      getIndexRoute(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/components/UserProfile/Profile/Profile`,
        )
          .then(module => {
            cb(null, { component: module.default });
          })
          .catch(errorLoading);
      },
    },
    {
      path: 'profile(/:webname)',
      onEnter: onEnterProfile,
      getComponent(location, cb) {
        const conditionalComponent = createConditionalComponent({
          condition: userProfile2Enabled,
          ifTrueOptions: {
            importer: () => {
              return System.import(
                /* webpackChunkName: "c_user-profile-new" */ `${BASE_PATH}/src/domains/listener/userProfile/components/UserProfile`,
              );
            },
            component: 'UserProfile',
          },
          ifFalseOptions: {
            importer: () => {
              return System.import(
                /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/containers/UserProfile/UserProfile`,
              );
            },
            component: 'UserProfile',
          },
        });

        cb(null, conditionalComponent);
      },
      getIndexRoute(location, cb) {
        const conditionalComponent = createConditionalComponent({
          condition: userProfile2Enabled,
          ifFalseOptions: {
            importer: () => {
              return System.import(
                /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/components/UserProfile/Profile/Profile`,
              );
            },
            component: 'Profile',
          },
        });

        cb(null, { component: conditionalComponent });
      },
    },
    {
      path: 'feed(/:webname)',
      onEnter: onEnterProfile,
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/containers/UserProfile/UserProfile`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
      getIndexRoute(location, cb) {
        System.import(
          /* webpackChunkName: "c_user-profile" */ `${BASE_PATH}/src/components/UserProfile/Profile/Profile`,
        )
          .then(module => {
            cb(null, { component: module.default });
          })
          .catch(errorLoading);
      },
    },
  ]);
}

function buildAccountRoutes({
  routes,
  AppContainer,
  errorLoading,
  redirectIfAuthenticated,
  redirectIfAuthenticatedOnChange,
  redirectIfAuthenticatedOrBlocked,
  createConditionalComponent,
  AsyncDomain,
  onEnterMobileAccountWelcome,
  isMobileWeb,
  isTablet,
}) {
  const accumulativeRoutes = routes.concat([
    {
      path: 'account',
      component: AppContainer,
      childRoutes: [
        {
          path: 'help',
          component: AsyncDomain,
          props: {
            domain: 'listener',
            component: 'ForgotPassword',
            key: 'ForgotPassword',
          },
        },
        {
          path: 'sign-in',
          onEnter: redirectIfAuthenticated,
          onChange: redirectIfAuthenticatedOnChange,
          component: AsyncDomain,
          props: {
            domain: 'listener',
            component: 'Login',
            key: 'Login',
          },
        },
        {
          path: 'sign-out',
          getIndexRoute(location, cb) {
            System.import(
              /* webpackChunkName: "logout" */ `${BASE_PATH}/src/components/Logout/Logout`,
            )
              .then(module => {
                cb(null, { component: module.default });
              })
              .catch(errorLoading);
          },
        },
        {
          path: 'community-redirect',
          component: AsyncDomain,
          props: {
            domain: 'listener',
            component: 'CommunityRedirect',
            key: 'CommunityRedirect',
          },
        },
        {
          path: 'register/not-available',
          component: AsyncDomain,
          props: {
            domain: 'listener',
            component: 'RegisterNotAvailable',
            key: 'RegisterNotAvailable',
          },
        },
        {
          path: 'register',
          component: AsyncDomain,
          onEnter: redirectIfAuthenticatedOrBlocked,
          props: {
            domain: 'listener',
            component: 'Register',
            key: 'Register',
          },
        },
        {
          path: 'reset-password',
          onEnter: redirectIfAuthenticated,
          component: AsyncDomain,
          props: {
            domain: 'listener',
            component: 'ResetPassword',
            key: 'ResetPassword',
          },
        },
      ],
    },
  ]);

  if (isMobileWeb || isTablet) {
    accumulativeRoutes.push({
      path: 'account/:accountAction/welcome',
      onEnter: onEnterMobileAccountWelcome,
      component: AsyncDomain,
      props: {
        domain: 'payments',
        component: 'WelcomeMobile',
        key: 'WelcomeMobile',
      },
    });
  }

  return accumulativeRoutes;
}

function buildDesktopRoutes({ routes, errorLoading }) {
  return routes.concat([
    {
      path: 'open',
      getComponent(location, cb) {
        System.import(
          /* webpackChunkName: "c_desktop-landing" */ `${BASE_PATH}/src/containers/DesktopLanding/DesktopLanding`,
        )
          .then(module => {
            cb(null, module.default);
          })
          .catch(errorLoading);
      },
    },
  ]);
}

export default {
  buildSocialRoutes,
  buildAccountRoutes,
  buildDesktopRoutes,
};
